"use client";

import React from "react";
import type { SupportMessageStatus } from "./types";

interface SupportStatusBadgeProps {
  status: SupportMessageStatus;
  ticketId?: string | null;
}

const STATUS_META: Record<
  SupportMessageStatus,
  { emoji: string; label: string; className: string }
> = {
  new: {
    emoji: "🆕",
    label: "New",
    className:
      "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800",
  },
  logged: {
    emoji: "💬",
    label: "Logged",
    className:
      "bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800/60 dark:text-gray-300 dark:border-gray-700",
  },
  ticket: {
    emoji: "🎫",
    label: "Ticket",
    className:
      "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-300 dark:border-green-800",
  },
  ticket_and_logged: {
    emoji: "🎫💬",
    label: "Ticket + Logged",
    className:
      "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-300 dark:border-green-800",
  },
};

/**
 * Small status pill for a support-inbox message/thread. Mirrors the design-doc
 * badges: 🆕 New / 💬 Logged / 🎫 Ticket / 🎫💬 both.
 */
export function SupportStatusBadge({ status }: SupportStatusBadgeProps) {
  const meta = STATUS_META[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${meta.className}`}
    >
      <span aria-hidden>{meta.emoji}</span>
      <span>{meta.label}</span>
    </span>
  );
}
